export default __webpack_public_path__ + "static/media/wooden.4b785d77.jpeg";